import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

import { getUnreadCount } from 'selectors/InquirySelectors';
import { fetchUnreadCounts } from 'actions/InquiryActions';

import styles from './Inbox.module.less';

export const Inbox = (): JSX.Element => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUnreadCounts());
  }, [dispatch]);
  const unreadCount = useSelector(getUnreadCount) || 0;
  const hasMoreThanOneDigit = unreadCount > 9;
  const showMessages = unreadCount && unreadCount > 0;
  return (
    <div className={styles.inbox}>
      Your Vendor Inquiries
      {showMessages ? (
        <div
          data-testid="unread-messages-count"
          className={cx(styles.unreadCount, {
            [styles.manyMessages]: hasMoreThanOneDigit,
          })}
        >
          {unreadCount}
        </div>
      ) : undefined}
    </div>
  );
};
